if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Check required personalization properties if present
        const customInputs = this.form.querySelectorAll(
          '#personalisation-text, input[name="properties[Personalisation Text]"], input.required[name^="properties["]'
        );
        for (const input of customInputs) {
          if (input.disabled || (input.offsetParent === null && input.id !== 'personalisation-text')) {
            continue;
          }
          if (input.id === 'other-greeting') {
            const greetingSelect = this.form.querySelector('#greeting, select[name="properties[Greeting]"]');
            if (greetingSelect && greetingSelect.value !== 'Other (Enter Below)') {
              continue;
            }
          }
          if (!input.value || input.value.trim() === '') {
            input.classList.remove('shake-element');
            void input.offsetWidth;
            input.classList.add('has-error', 'shake-element');
            input.focus();
            return;
          }
        }

        // START ADD-ON INTERCEPT LOGIC
        const popup = document.getElementById('AddOnPopupModal');
        
        // --- Scratch Card Gamification Intercept ---
        const scratchTriggerContainer = document.getElementById('ScratchCardTriggerContainer');
        const scratchDataScript = document.getElementById('ScratchCardData');
        
        if (scratchDataScript && window.AWGS_ScratchAPI && !this.dataset.addonBypassed) {
          // Identify if current product belongs to a scratch collection
          const data = JSON.parse(scratchDataScript.textContent);
          const allHandles = new Set([data.current_collection_handle, ...(data.collections_in_cart || [])].filter(Boolean));
          let qualifyingHandle = null;
          
          if (typeof buyXgetYRewards !== 'undefined') {
            const possibleRewards = buyXgetYRewards.filter(r => r.type === 'buy_x_get_y');
            for (const reward of possibleRewards) {
              if (allHandles.has(reward.collection_handle)) {
                qualifyingHandle = reward.collection_handle;
                break;
              }
            }
          }
          
          // If we are on a PDP or have a qualifying collection data attribute
          const pdpScratchHandle = this.form.dataset.scratchCollection;
          if (pdpScratchHandle) qualifyingHandle = pdpScratchHandle;

          if (qualifyingHandle && !window.AWGS_ScratchAPI.isRevealed(qualifyingHandle)) {
            // Prevent popup, trigger scratch card
            window.AWGS_ScratchAPI.openForProduct(qualifyingHandle, () => {
              // After scratch, bypass normal intercept and continue to add-on flow
              if (popup) {
                popup.classList.add('is-active');
                popup.style.display = 'flex';
              } else {
                this.dataset.addonBypassed = 'true';
                this.submitButton.click();
              }
            });
            return;
          }
        }
        // --- End Scratch Card Intercept ---

        if (popup && !this.dataset.addonBypassed) {
          popup.classList.add('is-active');
          popup.style.display = 'flex';

          const closePopup = () => {
            popup.classList.remove('is-active');
            popup.style.display = 'none';
          };

          const ignoreBtn = document.getElementById('AddOnPopupIgnore') || popup.querySelector('.add-on-popup__ignore-link') || popup.querySelector('.add-on-popup__ignore-btn');
          if (ignoreBtn) {
            ignoreBtn.onclick = (e) => {
              e.preventDefault();
              closePopup();
              this.dataset.addonBypassed = 'true';
              this.submitButton.click();
            };
          }

          const closeBtn = document.getElementById('AddOnPopupClose') || popup.querySelector('.add-on-popup__close');
          if (closeBtn) {
            closeBtn.onclick = (e) => {
              e.preventDefault();
              closePopup();
              this.dataset.addonBypassed = 'true';
              this.submitButton.click();
            };
          }

          const overlay = document.getElementById('AddOnPopupOverlay') || popup.querySelector('.add-on-popup__overlay');
          if (overlay) {
            overlay.onclick = (e) => {
              e.preventDefault();
              closePopup();
              this.dataset.addonBypassed = 'true';
              this.submitButton.click();
            };
          }

          const addOnCards = popup.querySelectorAll('.add-on-popup__card');
          addOnCards.forEach((card) => {
            card.onclick = (e) => {
              e.preventDefault();
              e.stopPropagation();

              const targetUrl = card.dataset.addonUrl || card.querySelector('a')?.getAttribute('href');
              if (!targetUrl) return;

              if (card.classList.contains('is-loading')) return;
              card.classList.add('is-loading');

              // Prevent subsequent clicks
              addOnCards.forEach((c) => {
                c.style.pointerEvents = 'none';
              });
              if (ignoreBtn) ignoreBtn.disabled = true;

              const btn = card.querySelector('.add-on-popup__add-btn');
              if (btn) {
                btn.textContent = 'Adding...';
              }

              const formData = new FormData(this.form);
              const config = fetchConfig('javascript');
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type'];
              config.body = formData;

              const addUrl = window.routes?.cart_add_url || '/cart/add.js';
              fetch(addUrl, config)
                .then((res) => res.json())
                .then(() => {
                  window.location.href = targetUrl;
                })
                .catch((err) => {
                  console.error('Failed to add main product to cart:', err);
                  window.location.href = targetUrl;
                });
            };
          });

          return;
        }
        // END ADD-ON INTERCEPT LOGIC

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const isBuyNow = this.dataset.isBuyNow === 'true';

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart && !isBuyNow) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (isBuyNow) {
              window.location.href = window.routes?.root ? `${window.routes.root}checkout` : '/checkout';
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            delete this.dataset.addonBypassed;
            delete this.dataset.isBuyNow;
          });
      }

      toggleSubmitButton(disable = true, text = '', modifyClass = true) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) {
            const span = this.submitButton.querySelector('span');
            if (span) span.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          const span = this.submitButton.querySelector('span');
          if (span) span.textContent = window.variantStrings?.addToCart || 'Add to cart';
        }

        if (!modifyClass) return;

        if (disable) {
          this.submitButton.classList.add('disabled');
        } else {
          this.submitButton.classList.remove('disabled');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );

  // Global intercept for Dynamic Checkout / Buy Now buttons
  document.addEventListener(
    'click',
    function (e) {
      const buyNowBtn = e.target.closest(
        '.shopify-payment-button__button, .shopify-payment-button button, [data-testid="Checkout-button"]'
      );
      if (!buyNowBtn) return;

      const popup = document.getElementById('AddOnPopupModal');
      const productFormEl = document.querySelector('product-form');
      if (popup && productFormEl && !productFormEl.dataset.addonBypassed) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        productFormEl.dataset.isBuyNow = 'true';
        productFormEl.submitButton?.click();
      }
    },
    true
  );

  // Reset modal state if user navigates back (e.g. from bfcache)
  window.addEventListener('pageshow', function () {
    const popup = document.getElementById('AddOnPopupModal');
    if (popup) {
      popup.querySelectorAll('.add-on-popup__card').forEach((c) => {
        c.classList.remove('is-loading');
        c.style.pointerEvents = '';
        const btn = c.querySelector('.add-on-popup__add-btn');
        if (btn) btn.textContent = 'Personalise & Order';
      });
      const ignoreBtn = document.getElementById('AddOnPopupIgnore') || popup.querySelector('.add-on-popup__ignore-btn');
      if (ignoreBtn) ignoreBtn.disabled = false;
    }
  });
}


